<ng-container [ngSwitch]="desktopTemplate">
    <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="modexssm"></ng-container>
    <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="modexssm"></ng-container>
    <ng-container *ngSwitchCase="'md'" [ngTemplateOutlet]="modexssm"></ng-container>
    <ng-container *ngSwitchDefault [ngTemplateOutlet]="modelgxl"></ng-container>
</ng-container>


<ng-template #modexssm>
    <div class="card-wrapper-mobile" [class.disablecard]="loading">

        <div class="card-body">

            <div class="card-header">
                <mat-icon >event</mat-icon>
                <span class="ml5">{{tmp_offer?.travelDate?.duration + ' Nächte'}}</span>
                <span>&minus; {{tmp_offer?.travelDate?.fromDate | date}} - {{tmp_offer?.travelDate?.toDate
                    |date}}</span>
            </div>

            <div class="card-share">
                <ng-container *ngIf="bookable && validated">
                    <ng-container *ngTemplateOutlet="offerSchar"></ng-container>
                </ng-container>
            </div>
        </div>

        <div class="info-body-wrapper-mobile">

            <div class="info-body-mobile">
                <div class="fl-wrapper-mobile">
                    <clever-flugdata [flightOffer]="tmp_offer?.flightOffer" [mode]="realparams?.productType">
                    </clever-flugdata>
                </div>
            </div>

            <!--price section-->
            <div class="prc-body-mobile">
                <!--price section-->
                <div class="op-wrapper">
                    <img class="lazyload opim" *ngIf="headpng?.length > 0" data-src="{{headpng}}" alt="Veranstalter">
                </div>

                <div class="prcinfo-wrpapper">
                    <div class="prc-info-mobile">
                        <span><span class="prc">{{tmp_offer?.personPrice?.value | number}}
                                {{tmp_offer?.personPrice?.currency}}</span> p.P.</span>
                        <span class="subprc">
                            Gesamtpreis {{tmp_offer?.totalPrice.value | number}} {{tmp_offer?.totalPrice?.currency}}
                        </span>
                        <ng-container *ngIf="showFlex">
                            <div class="fsm" [matTooltip]="kostenlosStorno" matTooltipPosition="above">
                                <span class="fsinfo">{{serviceCodeFS}}</span>
                                <mat-icon  class="fsico">info</mat-icon>
                            </div>
                        </ng-container>
                    </div>
                    <div class="prcbtn-wrapper">
                        <ng-container *ngIf="!loading && !validated">
                            <button (click)="checkOffer()" class="btnb">ANGEBOT PRÜFEN</button>
                        </ng-container>
                        <ng-container *ngIf="!loading && validated && bookable">
                            <button (click)="insertAndGoToBooking()" class="btnb succ w100" matRipple>FLUG
                                BUCHEN</button>
                            <ng-container *ngIf="currentCustomer?.asPartner">
                                <div class="btnwww">
                                    <ng-container *ngIf="!packloading; else myloading">
                                        <button *ngIf="!inOfferpack" class="btnb btnbhi"
                                            matTooltip="Zur Angebotsliste hinzufügen" (click)="addToOfferpackList()">
                                            <mat-icon>open_in_new</mat-icon>
                                        </button>
                                    </ng-container>
                                    <button *ngIf="inOfferpack" class="btnb btnbhi mat-warn"
                                        matTooltip="Von Angebotsliste entfernen" (click)="removeFromOfferpackList()">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </div>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="!loading && validated && !bookable">
                            <span class="errorcol">Angebot ist ausgebucht</span>
                        </ng-container>
                        <ng-container *ngIf="loading">
                            <mat-spinner diameter="30" style="margin:auto"></mat-spinner>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #modelgxl>
    <div class="card-wrapper" [class.disablecard]="loading">

        <div class="card-body">

            <div class="card-header">
                <mat-icon >event</mat-icon>
                <span class="ml5">{{tmp_offer?.travelDate?.duration + ' Nächte'}}</span>
                <span>&minus; {{tmp_offer?.travelDate?.fromDate | date}} - {{tmp_offer?.travelDate?.toDate
                    |date}}</span>
            </div>

            <div class="card-share">
                <ng-container *ngIf="bookable && validated">
                    <ng-container *ngTemplateOutlet="offerSchar"></ng-container>
                </ng-container>
            </div>
        </div>

        <div class="info-body-wrapper">

            <div class="info-body">
                <div class="fl-wrapper">
                    <clever-flugdata [flightOffer]="tmp_offer?.flightOffer" [mode]="realparams?.productType">
                    </clever-flugdata>
                </div>
            </div>

            <!--price section-->
            <div class="prc-body">
                <!--price section-->
                <div class="op-wrapper">
                    <img class="lazyload opim" *ngIf="headpng?.length > 0" data-src="{{headpng}}" alt="Veranstalter">
                </div>

                <div class="prcinfo-wrpapper">
                    <div class="prc-info">
                        <span><span class="prc">{{tmp_offer?.personPrice?.value | number}}
                                {{tmp_offer?.personPrice?.currency}}</span> p.P.</span>
                        <span class="subprc">
                            Gesamtpreis {{tmp_offer?.totalPrice.value | number}} {{tmp_offer?.totalPrice?.currency}}
                        </span>
                        <ng-container *ngIf="showFlex">
                            <div class="fs" [matTooltip]="kostenlosStorno" matTooltipPosition="above">
                                <span class="fsinfo">{{serviceCodeFS}}</span>
                                <mat-icon  class="fsico">info</mat-icon>
                            </div>
                        </ng-container>
                    </div>
                    <div class="prcbtn-wrapper">
                        <ng-container *ngIf="!loading && !validated">
                            <button (click)="checkOffer()" class="btnb">ANGEBOT PRÜFEN</button>
                        </ng-container>
                        <ng-container *ngIf="!loading && validated && bookable">
                            <button (click)="insertAndGoToBooking()" class="btnb succ w100" matRipple>FLUG
                                BUCHEN</button>
                            <ng-container *ngIf="currentCustomer?.asPartner">
                                <div class="btnwww">
                                    <button *ngIf="!inOfferpack" class="btnb btnbhi"
                                        matTooltip="Zur Angebotsliste hinzufügen" (click)="addToOfferpackList()">
                                        <mat-icon>open_in_new</mat-icon>
                                    </button>
                                    <button *ngIf="inOfferpack" class="btnb btnbhi mat-warn"
                                        matTooltip="Von Angebotsliste entfernen" (click)="removeFromOfferpackList()">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </div>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="!loading && validated && !bookable">
                            <span class="errorcol">Angebot ist ausgebucht</span>
                        </ng-container>
                        <ng-container *ngIf="loading">
                            <mat-spinner diameter="30" style="margin:auto"></mat-spinner>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #myloading>
    <mat-spinner diameter="20"></mat-spinner>
</ng-template>

<ng-template #offerSchar>
    <app-share [extratoexex]="extratoexecforshare" [description]="tmp_offer?.travelDate?.duration + ' Nächte' + ' ' + (tmp_offer?.travelDate?.fromDate | date) + ' - ' + (tmp_offer?.travelDate?.toDate
            |date) + ' ' + ' ab ' + (tmp_offer?.personPrice?.value | number:'1.2-2') + ' € p.P.'"
        [title]="(this.realparams.productType === 'flight' ? 'Hin- und Rückflug | ' : 'nur Hinflig | ') + 
        tmp_offer?.flightOffer?.flight?.departureAirport?.name + ' (' + tmp_offer?.flightOffer?.flight?.departureAirport?.code + ') - ' + 
        tmp_offer?.flightOffer?.flight?.arrivalAirport?.name + ' (' + tmp_offer?.flightOffer?.flight?.arrivalAirport?.code + ')'"></app-share>
</ng-template>